/* eslint-disable @angular-eslint/no-output-on-prefix */

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
} from '@angular/core';
import { ControlValueAccessorDirective } from '@shared/directives';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { CCS_RADIO_GROUP_VALUE_ACCESSOR_PROVIDER } from './providers/ccs-radio-group-value-accessor.provider';
import { RadioGroupInputOptions } from './interfaces/radio-group-input-options.interface';

@Component({
  selector: 'app-ccs-radio-group',
  templateUrl: 'ccs-radio-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatRadioGroup, MatRadioButton, ReactiveFormsModule],
  providers: [CCS_RADIO_GROUP_VALUE_ACCESSOR_PROVIDER],
})
export class CcsRadioGroupComponent<
  T,
> extends ControlValueAccessorDirective<T> {
  @Input({ required: true }) public options: RadioGroupInputOptions[] = [];
  @Input({ required: true }) public label = '';

  public onFocus = output<FocusEvent>();
  public onBlur = output<FocusEvent>();
}
